/* eslint-disable react/no-array-index-key */
/**
 */

import React from 'react';
import KmMarker from 'components/KmMarker';
import { pointsDistance } from 'utils/getDistance';
import getStepDistance from '../Virtual/VirtualView/getStepDistance';

function interpolate(p1, p2, d1, d2, d) {
  const f = (d - d1) / (d2 - d1);
  const lat = p1.lat + (p2.lat - p1.lat) * f;
  const lng = p1.lng + (p2.lng - p1.lng) * f;
  return { lat, lng };
}

function getKmMarkers(points, zoom, units) {
  const stepDistance = getStepDistance(zoom, units);
  const div = units === 'km' ? 1 : 1.60934;
  const digits = stepDistance < 1000 ? 1 : 0;
  const kmMarkers = [];
  const formatDistance = d => (d / 1000).toFixed(digits);
  let nextDistance = stepDistance;
  let lastData = { latlng: points[0], distance: 0 };
  let distance = 0;
  points.slice(1).forEach(latlng => {
    distance += pointsDistance(lastData.latlng, latlng) / div;
    while (distance >= nextDistance) {
      const pos = interpolate(
        lastData.latlng,
        latlng,
        lastData.distance,
        distance,
        nextDistance,
      );
      kmMarkers.push(
        <KmMarker
          key={nextDistance}
          pos={pos}
          km={formatDistance(nextDistance)}
        />,
      );
      nextDistance += stepDistance;
    }
    lastData = { latlng, distance };
  });
  return kmMarkers;
}

export default getKmMarkers;
